import { render, staticRenderFns } from "./HeroPage.vue?vue&type=template&id=f166cf0e&"
import script from "./HeroPage.vue?vue&type=script&lang=js&"
export * from "./HeroPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports